// Marks a row of a phone list for a moment, when the reader comes back from its page.
export function highlightPhoneRow(element) {
  const row = element.closest('.base-phone-row');
  if (!row) return;
  row.classList.add('is-highlighted');
  setTimeout(() => row.classList.remove('is-highlighted'), 1200);
}
